<script setup lang="ts">
import { uniqueId } from "lodash-es"
import { onBeforeMount } from "vue"
import ComboBoxV2 from "./ComboBoxV2.vue"
import createGraphQLSource from "./sources/createGraphQLSource"
import { type ComboBoxStore, useComboBoxStore } from "./store"

const props = defineProps<{
  name: string
  title: string
}>()

const store: ComboBoxStore = useComboBoxStore(uniqueId("titleStore"))
const { source, query, isSingleSelect, useInputValueByDefault, field } =
  storeToRefs(store)

onBeforeMount(async () => {
  // Set query synchronously before awaiting — the source resolves after mount
  // and will wipe user input that's been typed in the meantime.
  isSingleSelect.value = true
  useInputValueByDefault.value = true
  query.value = props.title
  field.value = "title"
  source.value = await createGraphQLSource("PdlAutocompleteQuery")
})
</script>

<template>
  <ComboBoxV2
    :name="name"
    :store="store"
    :readonly="true"
    placeholder="Search titles"
  />
</template>
